// ErrorState — 1:1 port of legacy `src/ui/ErrorState.jsx`.
import { Button } from './Button.js';
import { Icon } from './Icon.js';
import { useTranslation } from 'react-i18next';

export interface ErrorStateProps {
  title?: string;
  text?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({ title, text, onRetry, retryLabel }: ErrorStateProps) {
  const { t } = useTranslation('common');
  const resolvedTitle = title ?? t('states.errorTitle');
  const resolvedText = text ?? t('states.errorText');
  const resolvedRetryLabel = retryLabel ?? t('actions.retry');
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        gap: 10,
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 'var(--r-full)',
          background: 'var(--status-error-bg)',
          color: 'var(--status-error-fg)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name="timer-off" size={22} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--fg-1)' }}>{resolvedTitle}</div>
      <div style={{ fontSize: 13, color: 'var(--fg-2)', maxWidth: 360 }}>{resolvedText}</div>
      {onRetry && (
        <Button kind="secondary" icon="rotate-ccw" onClick={onRetry}>
          {resolvedRetryLabel}
        </Button>
      )}
    </div>
  );
}
